import styled from 'styled-components';
import colors from '../../../../helpers/colors';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { GridItem } from '../../../Grid';
import LogoLink from '../../../LogoLink';
import NavMobile from '../../NavMobile';
import { desktopHeaderHeight } from '../styles';

export const MegamenuZIndex = 8;

export const MegaMenuContainer = styled.nav<{
  isSticky: boolean;
}>`
  background-color: ${colors.core02};
  z-index: ${MegamenuZIndex};
  position: ${(props) => (props.isSticky ? 'fixed' : 'block')};
  width: 100%;
  top: 0;
  left: 0;
  border-bottom: 1px solid ${colors.neutral05};

  ${mediaQuery.tabletLandscape`
    border-bottom: 0px;
 `}
`;

export const StyledGridItem = styled(GridItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: ${spacing(7)};

  ${mediaQuery.tabletPortrait`
    height: ${spacing(8)};
  `}

  ${mediaQuery.tabletLandscape`
    align-items: stretch;
    height: ${desktopHeaderHeight};
  `}
`;

export const Logo = styled(LogoLink)`
  display: flex;
  align-items: center;
  flex: 1;

  ${mediaQuery.tabletLandscape`
    display: none;
  `}

  img {
    height: ${spacing(3)};

    ${mediaQuery.tabletLandscape`
      height: ${spacing(3.5)};
    `}
  }
`;

/* prop used for Motability to use to override font colour */
export const StyledNavMobile = styled(NavMobile)<{ fontColourVariant: boolean }>`
  max-height: calc(100vh - 100%);
  overflow-y: auto;
  // Setting overflow-y changes the default for overflow-x so we need to set it explicitly
  overflow-x: hidden;
`;
